export const communityConfigurationCardSx = {
  border: "1px solid",
  borderColor: "action.disabled",
  borderRadius: 2,
  p: 3,
};
